import React from "react";
import Card from "react-bootstrap/Card";
import Button from "react-bootstrap/Button";
import { CgWebsite } from "react-icons/cg";
import { Link } from 'react-router-dom'



function ProjectCards(props) {
  return (
    <Card className="project-card-view">
      <Card.Img variant="top" src={props.imgPath} alt="card-img" />
      <Card.Body>
        <Card.Title>{props.title}</Card.Title>
        <Card.Title>{props.company}</Card.Title>
        <Card.Text style={{ textAlign: "justify" }}>
          {props.description}
        </Card.Text>

        {"\n"}
        {"\n"}

        {/* If the component contains Demo link and if it's not a Blog then, it will render the below component  */}

        {!props.isBlog && props.demoLink && (
          <Link to ={props.demoLink}>
          <Button
            variant="primary"
            //href={props.demoLink}
            //target="_blank"
            style={{ marginLeft: "10px", align: "bottom"}}
          >
            <CgWebsite /> &nbsp;
            {"Explore"}
          </Button>
          </Link>
        )}
      </Card.Body>
    </Card>
  );
}
export default ProjectCards;
